<template>
  <div class="d-flex align-items-stretch dashboard">
    <!-- Sidebar -->
    <button
      class="btn-toggler"
      @click="handleClickToggler"
      :class="{ 'is-active': this.isShowSidebar }"
    >
      <div
        class="hamburger hamburger--squeeze js-hamburger"
        :class="{ 'is-active': this.isShowSidebar }"
      >
        <div class="hamburger-box">
          <div class="hamburger-inner"></div>
        </div>
      </div>
    </button>
    <div id="sidebar-wrapper" :class="sidebarClassList">
      <side-bar></side-bar>
    </div>
    <!-- Page Content -->
    <div id="page-content-wrapper" class="col p-0 d-flex">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import TopNavBar from "@/components/admin/layout/TopNavBar";
import SideBar from "@/components/admin/layout/SideNavBar";

export default {
  components: {
    TopNavBar,
    SideBar
  },
  data() {
    return {
      isShowSidebar: false
    };
  },
  computed: {
    sideBar() {
      return this.$store.state.sideBar;
    },
    sidebarClassList() {
      return { hide: !this.isShowSidebar };
    }
  },
  methods: {
    handleClickToggler() {
      this.isShowSidebar = !this.isShowSidebar;
    },
    async initFcm() {
      try {
        if (this.$messaging) {
          await this.$messaging.requestPermission();
          console.debug("Notification permission granted.");

          await this.initWebPush();
        } else {
          console.debug("Could not init Firebase Messaging.");
        }
      } catch (error) {
        throw error;
      }
    },
    async initWebPush() {
      await navigator.serviceWorker
        .register(window.location.origin + "/static/firebase-messaging-sw.js")
        .then(async registration => {
          console.debug("register serviceWorker success");

          const fcmToken = await this.getFcmToken(
            "BKWV_-CAGdA5BgTpGmGILOtAbK-sCsucRDO2d1KswzMeqS8dui-9Qz-8Mj8WC1az4CtRqaD7BFo_5oVa8Lf6K_I",
            registration
          );

          await this.registerToken(fcmToken);

          this.$messaging.onMessage(payload => {
            console.debug("message incoming!", payload);
            this.$store.state.notification.push(payload);
            this.pushNotification(payload);
          });

          this.$messaging.onTokenRefresh(async () => {
            await this.initWebPush();
          });
        })
        .catch(error => {
          const msg = `Service Worker Error (${error})`;
          console.error(msg);
        });
    },
    async getFcmToken(vapidKey, serviceWorkerRegistration) {
      try {
        const currentToken = await this.$messaging.getToken({
          vapidKey,
          serviceWorkerRegistration
        });

        console.debug("Current Token >>>", currentToken);

        return currentToken;
      } catch (error) {
        throw error;
      }
    },
    async registerToken(token) {
      const permission = JSON.parse(
        localStorage.getItem("adminRolePermission")
      );
      console.table(process.env);

      const roleId = permission ? permission.roleId : null;
      let topic = `ADMIN_ROLE_ID-${roleId}`;

      if (roleId) {
        const env = process.env.DEPLOY_ENV;
        if (env !== "production") {
          topic = [env, topic].join("~");
        }

        console.debug("Subscribing to topic: ", topic);
        await this.subscribeFcm(token, topic);
      } else {
        throw new Error("roleId not found for this admin");
      }
    },
    async subscribeFcm(token, topic) {
      const serverKey =
        "key=AAAA4YkgoS8:" +
        "APA91bFmcqXiEJMntY_MXcNCXOnbB" +
        "-a77IEaldcUrnvMzVtVP4huR9dT6Ol5zV" +
        "-P3Z3Oq_Ut6r30GFy6aFb6zqSL5uGjU1Q3WnYoUcVcUlj" +
        "-9xWg-iIpsYIhlOPhAjG29aKu" +
        "-BVxjeO7IA8TRc4SYVQbiiM62nrBMA";

      await axios
        .post(
          `https://iid.googleapis.com/iid/v1/${token}/rel/topics/${topic}`,
          {},
          {
            headers: {
              Authorization: serverKey
            }
          }
        )
        .then(() => {
          console.debug("Subscribe to topic success");
        })
        .catch(e => {
          throw e;
        });
    },
    pushNotification(payload) {
      const vm = this;

      if (!payload.data.adminId) {
        const noti = new Notification(payload.notification.title, {
          body: payload.notification.body,
          icon: "/static/icons/logo-brj.png"
        });

        switch (payload.data.targetFeature) {
          case "CONVERSATION":
            noti.onclick = () => {
              this.$store.state.projectId = payload.data.projectId || "OTHER";
              this.$store.state.projectName =
                payload.data.projectName || "Other";

              localStorage.setItem(
                "projectId",
                payload.data.projectId || "OTHER"
              );
              localStorage.setItem(
                "projectName",
                payload.data.projectName || "Other"
              );

              vm.$router.push({
                name: "Contact",
                params: { contactId: payload.data.targetId }
              });
            };
            break;
          default:
        }
      }
    }
  },
  mounted() {
    this.initFcm();

    this.$store.state.notification = [];

    if (this.$messaging) {
      this.$messaging.onMessage(payload => {
        this.$store.state.notification.push(payload);
        this.pushNotification(payload);
      });

      this.$messaging.onTokenRefresh(async () => {
        await this.initWebPush();
      });
    }
  }
};
</script>

<style>
body {
  overflow-x: hidden;
}

#sidebar-wrapper {
  flex: 0 0 240px;
  background: #fff;
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  text-align: left;
  border-right: solid 1px #e0e0e0;
  overflow: auto;
}

.toggled#sidebar-wrapper {
  width: 50px;
}

#page-content-wrapper {
  max-width: calc(100% - 200px);
  padding-left: 0;
  background-color: #f9f9f9;
  text-align: left;
}

.title {
  font-size: 25px;
  font-weight: bold;
  color: #000;
}
.content-title {
  height: 75px;
}
/* add Montserrat later */
.content-title {
  padding: 0px 30px;
  padding-top: 20px;
  height: 110px;
  font-size: 32px;
  font-weight: bold;
  line-height: 0.68;
  letter-spacing: -0.2px;
  text-align: left;
  color: #000000;
  flex-shrink: 0;
}
.content-title h1 {
  font-size: 24px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: -0.1px;
  color: #000000;
}
.content-title .sub-title {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.63;
  letter-spacing: normal;
  color: #8c8786;
}
.content-title a {
  color: #8c8786;
}
.content-head {
  font-size: 40px;
  font-weight: bold;
  line-height: 0.68;
  letter-spacing: -0.2px;
  text-align: left;
  color: #000000;
}
.content-sub-head {
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: #9b9b9b;
}

.tab {
  font-size: 18px;
  font-weight: bold;
  line-height: 1.17;
  letter-spacing: -0.1px;
  text-align: center;
  color: #b9b9b9;
  cursor: pointer;
}
.tab.active {
  color: #000;
  border-bottom: 2px solid #ef7e18;
}

.btn-toggler {
  display: none;
  padding: 0;
  border: 1px solid #e0e0e0;
  transition: all 0.5s ease;
}

.btn-toggler:focus {
  outline: 0;
}

.hamburger {
  font: inherit;
  display: inline-block;
  overflow: visible;
  margin: 0;
  padding: 15px;
  cursor: pointer;
  text-transform: none;
  color: inherit;
  border: 0;
  background-color: transparent;
}

.hamburger-box {
  position: relative;
  display: inline-block;
  width: 30px;
  height: 20px;
}

.hamburger-inner,
.hamburger-inner:after,
.hamburger-inner:before {
  content: "";

  position: absolute;
  left: 0;
  width: 30px;
  height: 3px;
  border-radius: 4px;
  background-color: #ef7e18;
}

.hamburger-inner:before {
  top: -10px;
}

.hamburger-inner:after {
  top: 10px;
}

.hamburger.is-active .hamburger-inner,
.hamburger.is-active .hamburger-inner:after,
.hamburger.is-active .hamburger-inner:before {
  background-color: #ef7e18;
}

.hamburger-inner {
  top: 50%;
  display: block;
}

.hamburger.is-active:hover,
.hamburger:hover {
  opacity: 0.7;
}

.hamburger--squeeze.is-active {
  transform: rotate(45deg);
}

.hamburger--squeeze.is-active .hamburger-inner:before {
  top: 0;
  opacity: 0;
}

.hamburger--squeeze.is-active .hamburger-inner:after {
  top: 0;
  transform: rotate(-90deg);
}

@media (max-width: 768px) {
  .btn-toggler {
    display: block;
    position: fixed;
    left: 0;
    border-radius: 0;
    background: white;
    z-index: 9999;
  }

  .btn-toggler.is-active {
    left: 240px;
  }

  #sidebar-wrapper {
    width: 240px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    z-index: 9998;
  }

  #sidebar-wrapper.hide {
    transform: translateX(-240px);
  }

  #page-content-wrapper {
    max-width: none;
    width: 100%;
    flex: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin/layout/Dashboard.vue